<template name = "dateTemplate" lang="html">
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
		<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
			<div class="sidebar-header">
				<h5>Search</h5>
				<a href="" id="sidebarMenuClose"><i data-feather="x"></i></a>
			</div><!-- df-sidebar-header -->
			<div class="sidebar-body">
				<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C'">
					<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
					<div class="form-group">
						<label :for="form.id" class="d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left">{{platingData[form.id]}}</p>
						<!-- <input type="email" class="form-control" :name="form.id" v-model.lazy="platingData[form.id]" :id="form.id" :placeholder="form.name"> -->
					</div>
				</ul>
				<ul class="sidebar-nav" v-else-if="form.division === 'O'">
					<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left" v-if="form.value.length > 0"><span v-for="(form1, i) in form.value" v-if="form1.codeCode == platingData[form.id]">{{form1.codeName}}</span></p>
						<p class="mg-b-0 text-left" v-else>{{platingData[form.id]}}</p>
					</div>
				</ul>
				<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
					<div class="form-group">
						<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left" v-for="(form1, j) in form.value" v-if="platingData[form.id] == form1.codeCode">{{form1.codeName}}</p>
					</div>
				</ul>
				<ul class="sidebar-nav" v-for="(form, i) in dateSearchForms">
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left">{{platingData[form.id]}}</p>
					</div>
				</ul>
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components overflow-hidden">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item" aria-current="page">{{this.subName}}</li>
								<li class="breadcrumb-item active" aria-current="page">View</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}} View</h4>
						</nav>
					</div>
					<div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
						<router-link class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" :to="{name:this.$route.name.replace('_completion',''), params:{mid:this.properties.mid, type:'list'}}"><feather type="file" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>list</router-link>
                        <!-- <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-on:click="csvExport()"><feather type="file" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>SAMPLESHEET</button> -->
                        <!-- <b-button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" style="padding-bottom: 25px;" type="is-primary" @click="isComponentModalActive = true"><feather type="file" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>SAMPLESHEET</b-button> -->
                        <a href="#modal1" @click="" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="file" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>SAMPLESHEET</a>
					</div>
				</div>
				<div class=" pd-x-0 pd-lg-x-10 pd-xl-x-0">
					<div class="col-sm-6 col-lg-5 d-inline-block">
						<ul class="cardborder nav nav-tabs" id="myTab" role="tablist">
							<li class="nav-item"><a class="nav-link active" id="plating-tab" data-toggle="tab" href="#plating" role="tab" aria-controls="plating" aria-selected="true" @click="">Plating</a></li>
							<li class="nav-item"><a class="nav-link" id="plate-tab" data-toggle="tab" href="#plate" role="tab" aria-controls="plate" aria-selected="false">Plate</a></li>
						</ul>
					</div>
					<div class="card card-body">
						<div class="tab-content mg-t-20" id="myTabContent">
							<div class="tab-pane fade lm-overflow show active" id="plating" role="tabpanel" aria-labelledby="plating-tab">
								<!-- <div class="d-none d-md-block tx-right-f mg-xs-y-15-f">
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" v-if="platingData[state] == '99999'" v-on:click="rePlating()"><feather type="minus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>re-experiemnt</a>
								</div> -->
								<ul class="nav nav-line" id="myTab5" role="tablist">
									<li class="nav-item" v-for="(form, i) in tabHeader" v-if="properties.mid === form.id"><a class="nav-link active" v-on:click='classifySampleHeader(form.id, tabHeader.length, i)' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a></li>
									<li class="nav-item" v-else><a class="nav-link"  v-on:click='classifySampleHeader(form.id, tabHeader.length, i)' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="profile" aria-selected="false">{{form.menuName}}</a></li>
								</ul>
								<div class="card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25">
									<div class="d-none d-md-block tx-right-f">
                                        <a href="#modal2" @click="getGroup()" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="minus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>re-plating</a>
										<a href="" @click="excelExport()" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="file-text" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Excel</a>
									</div>
									<section>
										<b-table id="btable" class="overflow-x-hidden b-table-fix-header" :data="isEmpty ? [] : sampleData" :checked-rows.sync="checkedRows" ref="table" checkable hoverable striped >
											<template slot-scope="props">
												<b-table-column v-for="(form, i) in sampleHeader" v-if="i == 0" :key="i" field="No" label="No">{{ props.row.no }}</b-table-column>
												<b-table-column v-else-if="Number(i) == 1" :key="form.id" :custom-key="form.id" :field="form.columnCode" :label="form.columnName" centered>
													<a href='#modal5' @click='sendId(props.row.id)' :id="props.index" data-toggle="modal" data-animation="effect-flip-horizontal"> {{ props.row[form.columnCode] }} </a>
												</b-table-column>
												<b-table-column v-else :key="i" :field="form.columnCode" :label="form.columnName" centered >{{ props.row[form.columnCode] }}</b-table-column>
											</template>
											<template slot="empty">
												<section class="section">
													<div class="content has-text-grey has-text-centered">
													<p>Nothing here.</p>
													</div>
												</section>
											</template>
										</b-table>
									</section>
								</div><!-- card -->
							</div><!-- tab -->
							<div class="tab-pane fade" id="plate" role="tabpanel" aria-labelledby="plate-tab">
								<div class="col-sm-6 col-lg-6 mg-t-10 mg-sm-t-0">
									<h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">{{Number(well_column)*Number(well_row)}} Well Plate</h6>
									<div class="form-group row row-nowrap">
										<number-input type="text" v-model.number='well_column' :min='1' :max='12' size="small" center></number-input>
										<span class='p-sm-2'>X</span>
										<number-input type="text" v-model.number='well_row' :min='1' :max='8' size="small" center></number-input>
									</div>
								<div id="custom-view">
									<ul class="board">
										<li class="fl tc w1 list2"></li>
										<li class="fl tc w1 list2" v-for='column in well_column'>{{(Number(column))}}</li>
									</ul>
									<!--- 리스트 --->
									<ul class="board" v-for='row in well_row'>
										<li class="fl tc w2 list2 pt-sm-2">{{well_row_a[(Number(row)-1)]}}</li>
										<div :id="'list'+row">
											<li class="fl tc w2 list1 pt-sm-2"  v-for='column in well_column' :id='well_row_a[(Number(row)-1)]+column'>
												<div>{{well_row_a[(Number(row)-1)]}}{{(Number(column))}}</div>
											</li>
										</div>
									</ul>
								</div>
							</div><!-- col -->
						</div><!-- tab -->
					</div>
				</div><!-- card -->
			</div>
		</div>
	</div>
	<div class="modal fade" id="modal5" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel5" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered chat-width" role="document">
			<div class="modal-content tx-14 chat-height">
				<div class="modal-header">
					<h6 class="modal-title" id="exampleModalLabel5">Chat</h6>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<Chat></Chat>
				</div>
			</div>
		</div>
	</div><!-- chat modal -->
    <div class="modal fade" style="background-color: rgba(0, 0, 0, 0.4);" id="modal1" tabindex="-1" role="dialog" aria-labelledby="limitModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width:570px;" role="document">
            <div class="modal-content tx-14">
                <div class="modal-header">
                    <h6 class="modal-title" id="limitModal">DOWNLOAD</h6>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row row-xs mt-1 d-block">
                        <div class="list-group">
                            <h6 class="is-pulled-left">• Version</h6>
                            <b-field
                                :type="chkType"
                                :message="chkMsg"
                                >
                                <b-select 
                                    v-model = "selectedOptions"
                                    placeholder="Select a character" 
                                    expanded
                                    :loading="selectLoading"
                                    >
                                    <option value="Original">Original</option>
                                    <option value="LRM">LRM</option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary tx-13" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary tx-13" v-on:click="csvExport(selectedOptions)">EXPORT</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" style="background-color: rgba(0, 0, 0, 0.4);" id="modal2" tabindex="-1" role="dialog" aria-labelledby="limitModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width:570px;" role="document">
            <div class="modal-content tx-14">
                <div class="modal-header">
                    <h6 class="modal-title" id="limitModal">Re-Plating</h6>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row row-xs mt-1 d-block">
                        <div class="list-group">
                            <h6 class="is-pulled-left">• Group</h6>
                            <b-field
                                :type="chkType"
                                :message="chkMsg"
                                >
                                <b-select 
                                    v-model = "selectedGroup"
                                    placeholder="Select a character" 
                                    expanded>
                                    <option
                                        v-for="option in editableGroup"
                                        :value="option.id"
                                        :key="option.id">
                                        {{ option.platingNo}}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary tx-13" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary tx-13" v-on:click="rePlating(selectedGroup)">Create</button>
                </div>
            </div>
        </div>
    </div>
</div>    
</template>
<script>
	// 공통 함수 관리 파일 임포트
	import common from "@/views/Common/common.js";
	// 멀티 드래그 앤 드롭 임포트
	import { Sortable, MultiDrag, Swap } from "sortablejs";
	Sortable.mount(new MultiDrag());
	Sortable.mount(new Swap());

	// Header의 메뉴 정보 호출을 위한 bus event
	import { bus } from "../../../main";
	// 이미지 드래거블
	import { Draggable } from 'draggable-vue-directive'
	// 결재, 채팅  
	import Approval from "@/views/Common/Approval";
	import Chat from "@/views/Common/Chat";
	import excel from '@/views/Common/excel.js';

	export default {
		name: "Detail",
		props: ["properties"],
		directives: {
		Draggable,
		},
		data() {
			return {
				mainName: "",
				subName: "",
				menuData: [], // header.vue data

				mid: "", // menu list id
				msid: "", // menu sheet id
				uid: "", // sheet id
				ssid: "", // sample list id
				rowNum: "", // sample group row number

				/* Plating input Form */
				platingHeader: [], // 입력 값 header column
				inputSearchForms: [], // 입력 input form
				dateSearchForms: [], // 입력 date form
				checkboxSearchForms: [], // 입력 radio form

				/* Plating 정보 Form Value */
				platingData: [], // 실험 정보 확인

				/* tab Header */
				tabHeader: [],

				checkedRows: [], // 그룹 체크 row 확인
				isEmpty: false,

				/* Sample Form */
				sampleHeader: [], // Plating Sample Header
				sampleData: [], // Plating Sample list data

				/* Well Plate index */
				well_column: 12,
				well_row: 8,
				well_row_a: ["A", "B", "C", "D", "E", "F", "G", "H"],
				well_data: [],

				last_plate:'', // 마지막 plate code

				/* Loading */
				isLoading: false,
				isFullPage: true,

				/* file upload */
				formData: "",

				state: '',
                selectedOptions : [],
                chkType : "normal",
                chkMsg  : "",
                subMenuId : "",
                editableGroup : [],
                selectLoading : false,
                selectedGroup : {}
			};
		},
		beforeDestroy() {
			bus.$off("menu_data");
		},
		created() {
			bus.$on("menu_data", data => {
				this.menuData = data;
				this.classifyHeader();
			});
			window.addEventListener('resize', this.handleResize);
			this.handleResize();
		},
		destroyed(){
			window.removeEventListener('resize', this.handleResize);
		},
		mounted() {
			this.$nextTick(function (){

			});
		},
		methods: {
			/*
			* Load Data Reception Headers
			*/
			async classifyHeader() {
				let data = common.menuHeader(this.properties.mid, this.menuData);
				this.mainName = data[0];
				this.subName = data[1];
				this.msid = data[2];
				this.platingHeader = data[3];
				this.state = common.find_sid_code(this.platingHeader, "statecode");
				this.tabHeader = common.tabOrder(this.properties.mid, this.menuData);
				this.inputSearchForms = [];
				this.dateSearchForms = [];
				this.checkboxSearchForms = [];
				for (let i in this.platingHeader) {
					if (this.platingHeader[i].columnType == "LIST") {
						if (this.platingHeader[i].columnAttr == "statecode") {
							this.inputSearchForms.push({name: this.platingHeader[i].columnName,value: this.platingHeader[i].code,id: this.platingHeader[i].columnCode,division: "O"});
						} else {
							this.checkboxSearchForms.push({name: this.platingHeader[i].columnName,id: this.platingHeader[i].columnCode,value: this.platingHeader[i].code,division: this.platingHeader[i].columnDivision});
						}
					} else if (this.platingHeader[i].columnType == "DATE") {
						this.dateSearchForms.push({name: this.platingHeader[i].columnName,value: "",id: this.platingHeader[i].columnCode,division: this.platingHeader[i].columnDivision});
					} else if (this.platingHeader[i].columnType == "COUNT") {
					} else {
						if (this.platingHeader[i].columnName == "No") {
						} else {
							if (!common.isNull(this.properties.uid)) {
								this.inputSearchForms.push({name: this.platingHeader[i].columnName,value: "",id: this.platingHeader[i].columnCode,division: this.platingHeader[i].columnDivision});
							} else {
								if (this.platingHeader[i].columnDivision == "C") {
									this.inputSearchForms.push({name: this.platingHeader[i].columnName,value: "",id: this.platingHeader[i].columnCode,division: this.platingHeader[i].columnDivision});
								}
							}
						}
					}
				}
				this.classifySampleHeader(this.properties.mid);
			},
			/*
			* Load Headers & Samples Data
			*/
			async classifyData() {
				this.sampleData = [];
				var thisData = [];
				var sampleData = [];
				if (!common.isNull(this.properties.uid)) {
                    console.log(this.subMenuId);
					var params = [];
					if (Array.isArray(this.ssid)) this.ssid = this.ssid[0];
					params = { ssid: this.ssid };
					// params = { mid: this.subMenuId };
					params["uid"] = this.properties.uid;
					var request = { params: params };
					await this.$axios.get(this.$apiHost + "/platinges/detail", request)
					.then(res => {
						console.log(res.data)
						this.platingData = res.data;
					})
					.catch(err => {console.log(err);});
					sampleData = common.makeData(this.platingData.samples, 1);
					for (let i in sampleData) {
						sampleData[i].no = Number(i) + 1;
						for (let j in this.sampleHeader) {
							// columnAttr이 plate 인경우 plate 위치를 찾아서 넣어준다.
							let colorCode = this.$randomColor();
							// if (this.sampleHeader[j].columnAttr === "plate") {
							// 	if(this.sampleHeader[j].columnCode === this.last_plate){
							// 		if (sampleData[i][this.sampleHeader[j].columnCode]) {
							// 			let list = document.getElementById("list" +(Number(this.well_row_a.indexOf(sampleData[i][this.sampleHeader[j].columnCode].substring(0, 1))) +1));
							// 			if (sampleData[i].divisionIdx > 0) {
							// 				list.childNodes[Number(sampleData[i][this.sampleHeader[j].columnCode].substr(1,sampleData[i][this.sampleHeader[j].columnCode].length)) - 1].innerText = sampleData[i][common.find_sid_code(this.sampleHeader, "sampleid")] + "D" +sampleData[i].divisionIdx;
							// 			} else {
							// 				//origin data
							// 				list.childNodes[Number(sampleData[i][this.sampleHeader[j].columnCode].substr(1,sampleData[i][this.sampleHeader[j].columnCode].length)) - 1].innerText = sampleData[i][common.find_sid_code(this.sampleHeader, "sampleid")];
							// 			}
							// 			list.childNodes[Number(sampleData[i][this.sampleHeader[j].columnCode].substr(1,sampleData[i][this.sampleHeader[j].columnCode].length)) - 1].style.color = "#ffffff";
							// 			list.childNodes[Number(sampleData[i][this.sampleHeader[j].columnCode].substr(1,sampleData[i][this.sampleHeader[j].columnCode].length)) - 1].style.backgroundColor = colorCode;
							// 		}
							// 	}
							// }
                            if (this.sampleHeader[j].columnType === "PIPELINE") {
                                sampleData[i][this.sampleHeader[j].columnCode] = sampleData[i]['pipeline'];
                            }
						}
						this.sampleData.push(sampleData[i]);
					}
				}
				let height = (Number(this.height) - (Number(this.height)/1.9))+'px';
				document.getElementById('btable').style.height = height;
				this.isLoading = false;
            },
            async csvExport(version){
                console.log(version)
                if(version == "LRM"){
                    console.log(this.platingData.samples)
                    common.LRMSampleSheetExport(this.platingHeader,this.platingData.samples,this.platingData,this.sampleHeader);
                    // this.$router.go({name:this.$route.name});
                }else if (version == "Original"){
                    common.originalSampleSheetExport(this.platingHeader,this.platingData.samples,this.platingData,this.sampleHeader);
                    // this.$router.go({name:this.$route.name});
                }else{
                    this.chkMsg = "Please select samplesheet version."
                    this.chkType = "is-danger"
                }
                
            },
			/*
			* First Load Previous Data & Samples Data
			*/
			async classifySampleHeader(id, tab_len, idx) {
				this.openLoading();
				idx = (tab_len - 1) == idx ? '' : tab_len;
				this.sampleHeader.splice(0, this.sampleHeader.length);
				this.$refs.table.newColumns.splice(0, this.$refs.table.newColumns.length);
				let thisMid = id.replace(/ /gi, "");
                this.subMenuId = thisMid;
				let parse = [];
				if (common.isNull(thisMid)) thisMid = this.properties.mid;
				let data = common.isNull(idx) ? common.makeHeader(thisMid, this.menuData, 2) : common.makeHeader(thisMid, this.menuData, 2, tab_len);
				if(thisMid == this.properties.mid) this.ssid = data[0];
				parse = data[1];
				parse.forEach((a,b)=>{
					if(Number(b)===0){
						this.sampleHeader = this.sampleHeader.concat({columnCode:'No'});
						this.sampleHeader = this.sampleHeader.concat(a);
					}else{
						if(a.mid === thisMid) this.sampleHeader = this.sampleHeader.concat(a);
						else if (!a.hasOwnProperty('mid')) this.sampleHeader = this.sampleHeader.concat(a);
					}
				});
				if(common.isNull(this.last_plate)) this.last_plate = common.find_last_column(this.sampleHeader, 'plate');
				console.log(this.sampleHeader)
				this.classifyData();
			},
			/*
			* List page Move (리스트 목록 페이지 이동)
			*/
			goPage() {
				
			},
            async getGroup(){
                this.selectLoading = true;
                this.editableGroup = [];
                await this.$axios.get(this.$apiHost + "/platinges/editable").then(res => {
                    this.editableGroup.push({platingNo:"New",id:''});
                    res.data.result.forEach(i => {
                        this.editableGroup.push(i);    
                    })
                    this.selectLoading = false;
                })
            },
            /*
			* Plating Data Check All
			*/
			async rePlating(group){
                this.isLoading = true;
				if(this.checkedRows.length == 0){
					this.chkMsg = "Please select sample."
                    this.chkType = "is-danger"
                    this.isLoading = false;
				}else{
				    let params = {headerId : this.properties.uid,selectedHeaderId:group, samples: []};
					var result = confirm('Are you sure you want to Re-Plating?');
					if (!result) {
						this.isLoading = false;
						return false;
					}
                    params['samples'] = this.checkedRows;

					this.$axios.post(this.$apiHost+'/platinges/onreexp', params)
					.then(res=>{
						sessionStorage.setItem('uid',this.properties.uid);
						this.isLoading = false;
						const timeoutObj = setTimeout(async () => {
							this.$router.go({name:this.$route.name});
						},1000);
					}).catch(err=>{
                        let error = err.response.data;
                        this.isLoading = false;
						if(err){
                            console.log(error.message)
                            if(error.message == "DUPLE"){
                                this.$buefy.dialog.alert({
                                    message: 'Duplication data exist.',
                                    size: 'is-medium',
                                    type: 'is-danger'
							    })
                            }else{
                                this.$buefy.dialog.alert({
                                    message: 'The system failed and the save failed. Please contact your system administrator.',
                                    size: 'is-medium',
                                    type: 'is-danger'
                                })
                            }
						}
					});
				}
			},
			/*
			* b-table Reception no click is chat.vue send uuid
			*/
			sendId(id){
				bus.$emit("receptid", id);
			},
			/*
			* page Loading bar
			*/
			openLoading() {
				this.isLoading = true;
				// setTimeout(() => {this.isLoading = false;}, 10 * 100);
			},
			handleResize() {
				this.width = window.innerWidth;
				this.height = window.innerHeight;
			},
			excelExport(){ 
				excel.excelExportDataParser(this.sampleData, this.sampleHeader);
			},
		},

		components: {
			Approval,
			Chat,
		},
		computed: {},
		watch: {}
	};
</script>
<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>


// WEBPACK FOOTER //
// src/views/Sequencing/Plating/CompletionForm.vue